export const IconResources = {
    SEARCH: {
        format: 'data',
        title: 'search-icon',
        viewBox: '0 0 24 24',
        path: 'M9 2a7 7 0 0 0 0 14 7 7 0 0 0 4.6-1.7l.4.4V16l6 6 2-2-6-6h-1.3l-.4-.4A7 7 0 0 0 9 2zm0 2a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5z'
    },
    CROSS: {
        format: 'data',
        title: 'cross-icon',
        viewBox: '0 0 24 24',
        path: 'M4.7 3.3L3.3 4.7l7.3 7.3-7.3 7.3 1.4 1.4 7.3-7.3 7.3 7.3 1.4-1.4-7.3-7.3 7.3-7.3-1.4-1.4-7.3 7.3-7.3-7.3z'
    }
};

export default IconResources;
